import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SigninService} from './signin.service';
import {Router} from '@angular/router';
import {User} from './user';
import {Rendezvous} from './rendezvous';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {DetectBrowserService} from '../../detect-browser.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  signinFormGroup: FormGroup;
  errorMsgConnexion: string;

  chromeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
    '/maVisio#Intent;package=com.android.chrome;scheme=https;S.browser_fallback_url=www.google.com;end';
  mozillaURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
    '/maVisio#Intent;package=org.mozilla.firefox;scheme=https;S.browser_fallback_url=www.google.com;end';
  edgeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
    '/maVisio#Intent;package=com.microsoft.emmx;scheme=https;S.browser_fallback_url=www.google.com;end';


  constructor(private signinService: SigninService, private router: Router, private sanitizer: DomSanitizer, private detectBrowserService: DetectBrowserService) {
    this.signinFormGroup = new FormGroup({
      referenceSinistre: new FormControl('', [Validators.required]),
      motDePasse: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    if (localStorage.getItem('refSinistre') && localStorage.getItem('tokenConnexion')) {
      this.router.navigate(['/dossier']);
    }
  }

  onSubmit() {
    if (this.signinFormGroup.valid) {
      const user = new User();
      user.dossierNumber = this.signinFormGroup.get('referenceSinistre').value;
      user.pinCode = this.signinFormGroup.get('motDePasse').value;

      this.signinService.login(user).subscribe(response => {
        if (response.Response) {
          localStorage.setItem('tokenConnexion', response.Response.Hash);
          localStorage.setItem('refSinistre', response.Response.Number);
          const rdv = new Rendezvous;
          rdv.begin = response.Response.BeginRdvDate;
          rdv.end = response.Response.EndRdvDate;
          localStorage.setItem('rendezvous', JSON.stringify((rdv)));
          this.router.navigate(['/dossier']);
        } else {
          this.errorMsgConnexion = 'La référence sinistre ou le mot de passe est invalide.';
        }
      }, () => {
        this.errorMsgConnexion = 'Une erreur technique est survenue.';
      });
    }

  }

  hideKeyBoard(event: any) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.target.blur();
    }
  }

  detectIncompatibleBrowser(): boolean {
    return this.detectBrowserService.isBrowserCompatible();
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/signin/signin.component.ts